// src/hasher.ts
import { bufferFromString } from "@fuel-ts/crypto";
import { sha256 } from "ethers";
function hashMessage(msg) {
  return sha256(bufferFromString(msg, "utf-8"));
}
function uint64ToBytesBE(value) {
  const bigIntValue = BigInt(value);
  const buffer = new ArrayBuffer(8);
  const dataView = new DataView(buffer);
  dataView.setBigUint64(0, bigIntValue, false);
  return new Uint8Array(dataView.buffer);
}
function hash(data) {
  return sha256(data);
}
export {
  hash,
  hashMessage,
  uint64ToBytesBE
};
//# sourceMappingURL=index.mjs.map